module.exports = __webpack_public_path__ + "img/pic-18.789eefd1.jpg";